<template>
    <div class="flex">
        <div class="dx-field flex-1">
            <div class="dx-field-label">Юридический</div>
            <ai-text-box-dictionary :value="data.kod_d_ur" title="Адреса">
                Выбор из справочника Адреса
            </ai-text-box-dictionary>
        </div>
        <DxButton class="self-end" icon="unselectall" />
    </div>
</template>

<script setup>
import { inject } from 'vue';
import DxButton from 'devextreme-vue/button';
import AiTextBoxDictionary from '@/components/ai-text-box-dictionary.vue';
const data = inject('serverData');
</script>
